/* @flow */
import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { css, names } from 'linaria';

import { API_URL } from '../../Constants';
import { Button, Icon, Text } from './core';
import Colors from '../constants/Colors';
import { Styles as TextInputStyles } from './core/TextInput';
import PhoneNumberInput from './PhoneNumberInput';
import MediaQueries from '../constants/MediaQueries';
import Segment from '../../utilities/Segment';

class DownloadLinkForm extends React.Component<
  {},
  {
    showSuccess: boolean,
    phoneNumber: ?string,
  }
> {
  state = {
    showSuccess: false,
    phoneNumber: '',
  };

  async sendDownloadLink(phoneNumber) {
    return fetch(`${API_URL}/website/send-download-link`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        phone_number: phoneNumber,
      }),
    });
  }

  _onPhoneNumberChange = async value => {
    this.setState({ phoneNumber: value });
  };

  _onSubmit = async e => {
    e.preventDefault();
    let { phoneNumber } = this.state;
    try {
      await this.sendDownloadLink(phoneNumber.replace(/\D/g, ''));
      Segment.track('Download Link Requested', {
        phoneNumber,
      });

      this.setState({ showSuccess: true });
    } catch (err) {
      console.error(err);
    }
  };

  _onReset = async e => {
    e.preventDefault();
    this.setState({ showSuccess: false });
  };

  render() {
    let { phoneNumber, showSuccess } = this.state;
    return (
      <div style={{ position: 'relative' }}>
        <ReactCSSTransitionGroup
          transitionName="FadeTransition"
          transitionAppear={true}
          transitionAppearTimeout={250}
          transitionEnter={true}
          transitionEnterTimeout={250}
          transitionLeave={true}
          transitionLeaveTimeout={250}>
          {showSuccess && (
            <div className={Styles.SuccessContainer}>
              <Text align="center" size="16">
                We sent a link to{' '}
                <Text tag="span" size="16" color={Colors.Black} weight="medium">
                  {phoneNumber}
                </Text>
              </Text>
              <a className={Styles.ResetLink} href="javascript:void(0);" onClick={this._onReset}>
                <Text size="16" weight="medium" color={Colors.Violet}>
                  <Icon name="undo" style={{ marginRight: 3 }} /> I typed the wrong number
                </Text>
              </a>
            </div>
          )}
        </ReactCSSTransitionGroup>
        <form className={Styles.Container} onSubmit={this._onSubmit}>
          <PhoneNumberInput
            placeholder="Enter phone number"
            value={phoneNumber}
            className={names(Styles.TextInput, TextInputStyles.Input)}
            onChange={this._onPhoneNumberChange}
          />
          <Button
            className={Styles.Button}
            theme="indigo"
            bordered={false}
            onClick={this._onSubmit}>
            Send link
          </Button>
        </form>
      </div>
    );
  }
}

const Styles = {
  Container: css`
    display: flex;
    margin-top: 30px;
    padding-left: 20px;
    ${MediaQueries.Large} {
      padding-left: 0;
    }
  `,
  TextInput: css`
    border-radius: 5px 0 0 5px;
    flex: 1;
  `,
  Button: css`
    border-radius: 0 5px 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  SuccessContainer: css`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${Colors.White};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  `,
  ResetLink: css`
    display: 'inline-block';
  `,
};

export default DownloadLinkForm;



// WEBPACK FOOTER //
// ./src/ui/components/DownloadLinkForm.js